import { memo } from 'react';

import { defectIsBinnenPeriodeNietInzetbaar } from '@/domain/defecten/defect';
import { Defect } from '@/types/Defecten';
import { dateWithDayOfWeekWithTime } from '@/utils/dateUtils';
import VirtualTable, { VirtualTableType } from '@/views/ddp/components/VirtualTable/VirtualTable';
import usePlankTableStore from '@/views/ddp/hooks/usePlankTableStore';

import DefectIcon from '../../defect/DefectIcon';
import DefectSidepanelListItem from '../../defect/DefectSidepanelListItem';

import styles from './Tabs.module.css';

const DefectenLijst = memo<VirtualTableType<Defect>>(VirtualTable);
const DefectItem = (defect: Defect) => <DefectSidepanelListItem defect={defect} />;

/** Sidepanel tab staat laat de defecten van een stel zien.
 *
 * @returns ReactNode
 */
const TabStaat = () => {
  const defect = usePlankTableStore((state) => state.sidepanel.defect);
  const defectByStel = usePlankTableStore((state) => state.defectenByStel);
  const nietMeerInzetbaarVanaf = usePlankTableStore(
    (state) => state.defectNietInzetbaarVanaf?.[String(state.sidepanel.eenheid)] ?? null,
  );
  return (
    <div className={styles.spStaatStyleDiv}>
      {defect && defectIsBinnenPeriodeNietInzetbaar({ ...defect, nietMeerInzetbaarVanaf }) && (
        <div className={styles.spStaatStyleNietInzetbaar24uur}>
          <DefectIcon.Zandloper xl className={styles.spStaatStyleNietInzetbaar24uurIcon} width='24px' height='24px' />
          <div className={styles.spStaatStyleNietInzetbaar24uurTitle}>{`Q-datum <12h`}</div>
          <div className={styles.spStaatStyleNietInzetbaar24uurDate}>
            {dateWithDayOfWeekWithTime(nietMeerInzetbaarVanaf)}
          </div>
        </div>
      )}
      <h6 className={styles.spStaatStyleHeader}>Defecten</h6>
      <div className={styles.spStaatStyleDefectTable}>
        <div className={styles.spStaatStyleDefectTableHeaders}>
          <div className={styles.spStaatStyleCol1}>Omschrijving defect</div>
          <div className={styles.spStaatStyleCol2}>Herstellen voor</div>
          <div className={styles.spStaatStyleCol3}>Melding</div>
        </div>
        <DefectenLijst data={defectByStel[String(defect?.eenheidNummer)] ?? []} height={400} renderRow={DefectItem} />
      </div>
    </div>
  );
};
export default TabStaat;
